<!--Banner-->
<ng-container *ngIf="name$ | async as name">
  <div class="d-lg-block d-none">
    <fgb-banner [title]="name"></fgb-banner>
  </div>
</ng-container>

<div class="d-block d-lg-none">
  <fgb-barcode [isHomePage]="true"></fgb-barcode>
</div>

<div class="widget-mobile">
  <div class="loyalty-feed">
    
    <fgbcl-loyalty-feed-list></fgbcl-loyalty-feed-list>
    
  </div>
  <!--Featured Rewards-->
  <div class="container">
    <fgbcl-featured-rewards [showAllPath]="'/rewards'"></fgbcl-featured-rewards>
  </div>
  <fgbcl-scorecard-carousel [icon]="'chevron_right'" [showAllView]="true"></fgbcl-scorecard-carousel>

  <div class="container">
    <!-- Announcements -->
    <fgb-announcements></fgb-announcements>
  </div>
</div>
